import { mdiFileTreeOutline, mdiHomeOutline } from '@mdi/js'
import access from '../vertical/access'
import api from '../vertical/api'
import financial from '../vertical/financial'
import logs from '../vertical/logs'
import products from '../vertical/products'
import setting from '../vertical/setting'
import users from '../vertical/users'
import marketing from '../vertical/marketing'

export default [
  {
    title: 'داشبورد',
    icon: mdiHomeOutline,
    to: 'home',
    action: 'can_see_dashboard',
    resource: 'all',
  },
  {
    title: 'دسته بندی ها',
    icon: mdiFileTreeOutline,
    to: 'newCategories',
    action: 'can_see_categories',
  },
  {
    title: 'دسته بندی های اپ',
    icon: mdiFileTreeOutline,
    to: 'app-categories',
    action: 'can_see_application_settings',
  },
  {
    title: 'اسلایدرهای اپ',
    to: 'app-collections',
    action: 'can_see_application_settings',
    resource: 'all',
  },
  ...products,
  ...setting,
  ...access,
  ...users,
  ...api,
  ...financial,
  ...logs,
  ...marketing,
]
